import * as React from 'react';
import { CollapsibleDropDown } from '../../../components/CollapsibleDropDown/CollapsibleDropDown';
import { darkGray } from '../../../consts/variables';
import { IFAQ } from '../../../interfaces/IFAQPage';

const styles: Record<string, React.CSSProperties> = {
    question: {
        fontSize: 15,
        lineHeight: '18px',
        padding: '18px 10px 18px 0',
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center',
        flex: '1 1 auto',
    },
    answer: {
        fontSize: 15,
        lineHeight: '20px',
    },
    wrapperStyle: {
        margin: '0 10px',
        padding: 0,
        borderBottom: `1px solid ${darkGray}`,
    },
    childStyle: {
        margin: 0,
        padding: 0,
    },
    arrowDownIcon: {
        paddingRight: 0,
        paddingLeft: 0,
    },
};
interface IProps extends IFAQ {
    wrapperStyle?: any;
}

export const FAQ = (props: IProps) => {
    const title = <div style={styles.question}>{props.question}</div>;
    return (
        <CollapsibleDropDown
            title={title}
            wrapperStyle={{ ...styles.wrapperStyle, ...props.wrapperStyle }}
            childStyle={styles.childStyle}
            arrowStyle={styles.arrowDownIcon}
        >
            <div style={styles.answer}>
                <div
                    className="faqPage--answers"
                    dangerouslySetInnerHTML={{ __html: props.text }}
                />
            </div>
        </CollapsibleDropDown>
    );
};
